<div class="skeleton-container">
  <div class="group">
    <ngx-skeleton-loader [theme]="{height: '50px', width:'100%', 'margin-bottom': '15px' }"
                         appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '30px', width:'100%', 'margin-bottom': '12px' }"
                         appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '30px', width:'100%', 'margin-bottom': '12px' }"
                         appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '30px', width:'100%', 'margin-bottom': '12px' }"
                         appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '30px', width:'100%', 'margin-bottom': '12px' }"
                         appearance="line"></ngx-skeleton-loader>
  </div>
  <div class="group">
    <ngx-skeleton-loader [theme]="{height: '50px', width:'100%', 'margin-bottom': '20px' }"
                         appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '30px', width:'100%', 'margin-bottom': '12px' }"
                         appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '30px', width:'100%', 'margin-bottom': '12px' }"
                         appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '30px', width:'100%', 'margin-bottom': '12px' }"
                         appearance="line"></ngx-skeleton-loader>
  </div>
</div>
